import AccessRestrictedPage from '../../components/AccessRestrictedPage';

const ProvedorPage = () => {
  return (
    <AccessRestrictedPage
      title="Fornecedores"
      message="O perfil CLIENT não possui endpoint compatível para consultar o cadastro administrativo de fornecedores. A tela foi bloqueada para impedir acesso a recursos restritos."
    />
  );
};

export default ProvedorPage;
